import { render, staticRenderFns } from "./ImageTooltip.vue?vue&type=template&id=284660a4&scoped=true&"
import script from "./ImageTooltip.vue?vue&type=script&lang=ts&"
export * from "./ImageTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./ImageTooltip.vue?vue&type=style&index=0&id=284660a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284660a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
